







































import Vue from "vue";
import router from "@/router";

export default Vue.extend({
  name: "Controls",
  data: () => {
    return {
      locale: router.currentRoute.params.locale as string,
      baseUrl: process.env.VUE_APP_MARKETPLACE_URL as string
    };
  }
});
